if (!customElements.get("product-hover-slider")) {
  class ProductHoverSlider extends HTMLElement {
    constructor() {
      super();
      this.swiperInstance = null;
      this.speed = parseInt(this.dataset.spped) || 500;
      this.effect = this.dataset.effectTest || "fade";
    }

    connectedCallback() {
      this.initSwiper();
      this.addEventListener("mouseenter", this.onHoverStart.bind(this));
      this.addEventListener("mouseleave", this.onHoverEnd.bind(this));
    }

    initSwiper() {
      const swiperEl = this.querySelector(".swiper");
      const paginationEl = this.querySelector(".swiper-pagination");
      if (!swiperEl || typeof Swiper === "undefined") return;

      this.swiperInstance = new Swiper(swiperEl, {
        effect: this.effect,
        speed: this.speed,
        loop: true,
        preloadImages: false,
        lazy: true,
        observer: true,
        observeParents: true,
        pagination: {
          el: paginationEl,
          type: "progressbar",
        },
        autoplay: {
          delay: 800,
          enabled: false,
        },
        allowTouchMove: false,
        navigation: false,
      });
    }

    onHoverStart() {
      if (this.swiperInstance && this.swiperInstance.autoplay) {
        this.swiperInstance.autoplay.start();
      }
    }

    onHoverEnd() {
      if (this.swiperInstance) {
        this.swiperInstance.autoplay.stop();
        this.swiperInstance.slideToLoop(0);
      }
    }

    disconnectedCallback() {
      if (this.swiperInstance) {
        this.swiperInstance.destroy();
      }
    }
  }

  customElements.define("product-hover-slider", ProductHoverSlider);
}
